<template>
  <section>
    <div v-if="solicitacoesCirurgia?.length" class="fast">
      <h6>{{ this.$t('cards.cirurgias') }}</h6>
      <div class="card">
        <div class="card-content">
          <ul class="list">
            <li
              v-for="(i, index) in solicitacoesCirurgia.slice(0, 3)"
              :key="i.CdCirurgia"
              class="item"
            >
              <div class="link is-vcentered">
                <i class="icon-ic_file_text2" /> {{ i.DsPrograma }} em
                {{ i.DtHrSolicitacao | formatarDataSolicitacao }} -
                {{ i.StatusCirurgia }}
              </div>
              <hr
                v-if="index == solicitacoesCirurgia.length - 1 ? false : true"
              />
            </li>
          </ul>
        </div>
      </div>
      <router-link to="/cirurgias" class="all is-pulled-right is-vcentered">
        {{ this.$t('botoes.ver-todos') }} {{ totalizadorSolicitacoes }}
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import { NotAuthenticatedError } from '../../../models/not-authenticated-error'
import { format } from 'date-fns'

export default {
  computed: {
    ...mapGetters({
      solicitacoesCirurgia: 'solicitacoesCirurgia'
    }),
    totalizadorSolicitacoes() {
      if (this.solicitacoesCirurgia && this.solicitacoesCirurgia.length > 0) {
        return `(${this.solicitacoesCirurgia.length})`
      }
      return ''
    }
  },
  beforeMount() {
    this.getSolicitacoesCirurgia().catch((err) => {
      if (err instanceof NotAuthenticatedError) router.push('/')
    })
  },
  methods: {
    ...mapActions(['getSolicitacoesCirurgia'])
  },
  filters: {
    formatarDataSolicitacao(value) {
      if (!value) return ''
      return format(new Date(value), 'dd/MM/yyyy')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
@import '~@/assets/stylesheets/card';

.fast {
  .card {
    max-height: 19.375rem;
  }

  .card-content {
    padding-top: 1.5625rem;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .list {
    .item {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;

      .link {
        i {
          vertical-align: bottom;
        }
      }
    }
  }

  .text {
    p {
      height: 1.5rem;
      width: 23.448125rem;

      color: var(--gray-700);
      font-family: Roboto;
      font-size: 1rem;
      line-height: 1.5rem;
    }

    span {
      padding-top: 0.625rem;
      height: 1rem;
      width: 13.150625rem;

      color: var(--gray-500);
      font-family: Roboto;
      font-size: 0.875rem;
      line-height: 1rem;
    }
  }
}
@media (max-width: 64rem) {
  .fast {
    .list .item {
      .link {
        display: flex;
        i {
          float: left;
          margin-right: 0.5rem;
        }
        :last-child {
          flex-grow: 0;
          text-align: left;
        }
      }
    }
    .card {
      height: 100%;
    }
  }
}
</style>
